export const colors = [
  'deepskyblue', 'goldenrod', 'teal', 'brown', 'hotpink',
  'orange', 'red', 'purple', 
  'fuchsia', 'green', 'lime', 'darkgreen', 'yellow', 'navy', 'blue', 
  'maroon', 'aqua', 'olive', 'aquamarine', 
];